import { Button, Stack, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import LogoLoader from "../components/LogoLoader";
import Page from "../components/Page";
// import ProfileAside from "../components/profile/ProfileAside";
import ProfileContent from "../components/profile/ProfileContent";
import ProfileHeader from "../components/profile/ProfileHeader";
import ProfileOtherInfos from "../components/profile/ProfileOtherInfos";
import ProfileProgression from "../components/_collab/home/ProfileProgression";
import { useSelector } from "react-redux";
import { ProfileContext } from "../contexts/ProfileContext";
import SideContentLayout from "../layout/SideContentLayout";
import peopleAPI from "../_api/_people";
import FaceIcon from "@mui/icons-material/Face";
import MatchingCandidateProfile from "../components/folder/matching/MatchingCandidateProfile";
import useFetch from "../hooks/useFetch";
import WorkIcon from "../icons/menu/work";
// import ProfileTopSoftSkills from "../components/profile/ProfileTopSoftSkills";
import TestsAPI from "../_api/_testsAPI";
import ShareModal from "./third_party/share/ShareModal";
import profileFormatter from "../_utils/formatters/profileFormatter";
import thirdPartiesAPI from "../_api/_thirdPartiesAPI";
import DeanonymizationButton from "../components/_third_party/profile/DeanonymizationButton";
import ThirdProfileList from "../components/profile/OtherInfos/ThirdProfileList";
import NoShareButton from "./third_party/share/NoShareButton";
import AskShareButton from "./third_party/share/AskShareButton";
import LastProjectCard from "../components/profile/LastProjectCard";
import UploadResumeModal from "../components/profile/Resume/UploadResumeModal";
import BenefCardTodoInfo from "../components/profile/BenefCardTodoInfo";
import TodoModalDetail from "../components/profile/TodoModalDetail";
import ProfileFileList from "../components/profile/profileDownloads/ProfileFileList";
import ProfileTasks from "../components/profile/tasks/ProfileTasks";

const ProfilePage: React.FC = () => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const {
    peopleResponse,
    peopleData,
    setPeopleData,
    tasks,
    tasksLoading,
    tasksProgress,
  } = useContext(ProfileContext);
  const context = useSelector((state: any) => state.auth.context);
  const tokenData = useSelector((state: any) => state.user);
  const menu = useSelector((state: any) => state.menu);
  const hasThirdMenu = useSelector((state: any) => state.menu.third_party);
  const isThird = context === "third_party";
  const thirdId = tokenData.thirdParty_id;
  const anonymous = peopleData?.anonymous;
  const sharePartners = peopleData?.otherData?.sharePartners;
  const isCre = context === "cre";
  const isRhOrAdvisor =
    context === "advisor" || context === "rh" || context === "manager";
  const hasThird =
    hasThirdMenu &&
    (context === "advisor" || context === "recruiter" || context === "cre");

  const canShareProfile =
    (context === "advisor" || context === "recruiter" || context === "cre") &&
    menu.third_party;

  const { id, profileId } = useParams();
  const queryParams = new URLSearchParams(window.location.search);

  const offerModal = queryParams.get("offerModal");

  const ftConnect = queryParams.get("ftconnect");

  const experiencesFTRef = useRef<any>(null);

  const ftConnectInit = useRef(ftConnect === "1");

  const [openMatchingModal, setOpenMatchingModal] = useState<boolean>(false);
  const [employeeData, setEmployeeData] = useState<any>();
  const [testData, setTestData] = useState<any>();
  const [tabChange, setTabChange] = useState<string>("");
  const [completenessData, setCompletenessData] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [thirdParties, setThirdParties] = useState<any>();
  const [openModalResume, setOpenModalResume] = useState(false);
  const [experiencesFT, setExperiencesFT] = useState<any>();
  const [isLoadingExperiencesFT, setIsLoadingExperiencesFT] =
    useState<boolean>(false);

  const [openDetailTodo, setOpenDetailTodo] = useState(false);
  const [tabSide, setTabSide] = useState<number>(0);
  const [ownerModal, setOwnerModal] = useState<string>("");
  const [todoDetail, setTodoDetail] = useState<any>();
  const testsData = useFetch(
    TestsAPI.get({ "person.id": id ?? tokenData?.person_id })
  );
  const isCES = useSelector((state: any) => state.user.isCES);
  const home = useSelector((state: any) => state.home);
  useEffect(() => {
    setTestData(testsData.data);
    setIsLoading(testsData.loading);
  }, [testsData]);

  //! Temporary

  const getCompleteness = async (id: string) => {
    setIsLoading(true);
    try {
      const completenessRes = await axios.get(
        peopleAPI.getById(`${id}/completeness`)
      );
      setCompletenessData(completenessRes.data);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };
  const getEmployeeData = async (id: string) => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        !isThird
          ? peopleAPI.getById(id)
          : thirdPartiesAPI.getById(`${thirdId}/profiles/${profileId}`)
      );
      setEmployeeData(profileFormatter(res.data));

      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  const [canEditPeople, setCanEditPeople] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(
        `companies/${tokenData.company_id}/parameters?filter=edit.canEditPeople&default=false`
      );
      const param = res?.data?.parameters?.canEditPeople;
      setCanEditPeople(
        isCES ? false : typeof param === "boolean" ? param : param === "true"
      );
    };
    fetchData();
  }, [tokenData.company_id, isCES]);

  const handleAddThirdParty = (newThirdParty: any) => {
    setThirdParties((prevThirdParties: any) => [
      ...prevThirdParties,
      newThirdParty,
    ]);
  };

  const getExperiencesFT = async (id: string) => {
    try {
      const experiencesFTRes = await axios.get(
        peopleAPI.getById(`${id}/info-ft?type=experience`)
      );
      experiencesFTRef.current = experiencesFTRes.data;
      setExperiencesFT(experiencesFTRes.data);
      setIsLoadingExperiencesFT(false);
    } catch (err) {
      console.log(err);
      setIsLoadingExperiencesFT(false);
    }
  };

  useEffect(() => {
    if (ftConnectInit.current) {
      getExperiencesFT(id ?? tokenData?.person_id);
      setOpenModalResume(true);
    }
  }, [id, tokenData?.person_id]);

  const { data, loading } = useFetch(
    peopleAPI.getById(`${id ?? tokenData?.person_id}/completeness`)
  );

  const returnNotCollabContext = () => {
    return (
      context !== "collab" && context !== "benef" && context !== "candidate"
    );
  };

  useEffect(() => {
    getCompleteness(id ?? tokenData?.person_id);
    // getTestsData(id ?? tokenData?.person_id);
    id && getEmployeeData(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, tokenData.person_id, profileId]);

  const fullName = `${
    employeeData
      ? employeeData.firstName
      : peopleResponse?.data?.firstName ?? ""
  } ${
    employeeData ? employeeData.lastName : peopleResponse?.data?.lastName ?? ""
  }`;

  useEffect(() => {
    if (peopleResponse.error?.status === 404) {
      console.log("PROFILERESPONSE ERROR REDIRECT", peopleResponse.error);
      navigate("/404", { replace: true });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [peopleResponse?.error]);

  useEffect(() => {
    setThirdParties(employeeData?.thirdParties);
  }, [employeeData]);

  const handleStatus = (status: any) => {
    (employeeData ? setEmployeeData : setPeopleData)?.((current: any) => ({
      ...current,
      status,
    }));
  };

  useEffect(() => {
    if (ftConnect) {
      sessionStorage.setItem("ftconnect", ftConnect);
    }
  }, [ftConnect]);

  useEffect(() => {
    if (!ftConnect && sessionStorage.getItem("ftconnect") === "1") {
      ftConnectInit.current = true;
      getExperiencesFT(id ?? tokenData?.person_id);
      setOpenModalResume(true);
    }
  }, [ftConnect, id, tokenData?.person_id]);

  const handleClose = () => {
    setOpenModalResume(false);
    sessionStorage.removeItem("ftconnect");
  };

  const seeTasks = () => {
    setTabSide(1);
  };

  return (
    <Page title={`${t("profile")} | ${fullName}`}>
      <LogoLoader open={peopleResponse.loading || isLoading || loading} />
      {((!peopleResponse.loading && peopleData && !id) ||
        (id && employeeData && !isLoading && !loading)) && (
        <>
          <SideContentLayout
            main={
              <>
                <ProfileHeader
                  notCollab={returnNotCollabContext()}
                  profileData={employeeData ? employeeData : peopleData}
                  completeness={id ? completenessData : data}
                  tabChange={setTabChange}
                  handleStatus={handleStatus}
                  seeTasks={seeTasks}
                  param={home?.paramjson}
                />
                <ProfileContent
                  employeeData={employeeData}
                  testData={testData}
                  notCollab={returnNotCollabContext()}
                  context={context}
                  loading={isLoading}
                  tabChange={tabChange}
                  candidateId={queryParams?.get("candidateId") ?? ""}
                  canEditPeople={canEditPeople}
                />
              </>
            }
            side={
              <Stack spacing={2}>
                {/* <ProfileAside /> */}
                {returnNotCollabContext() &&
                  !isThird &&
                  (isRhOrAdvisor || isCre ? (
                    <Button
                      onClick={() =>
                        navigate(`/app/profile/${id}/work-suggest`)
                      }
                      variant="contained"
                      sx={{ width: "100%", height: "50px" }}
                    >
                      <WorkIcon size={18} />
                      <Typography sx={{ ml: 1 }}>
                        {t("profilepage.see_work_matching")}
                      </Typography>
                    </Button>
                  ) : (
                    <Button
                      onClick={() => setOpenMatchingModal(true)}
                      variant="contained"
                      sx={{ width: "100%", height: "50px" }}
                    >
                      <FaceIcon />
                      <Typography sx={{ ml: 2 }}>
                        {t("profilepage.see_campaign_matching")}
                      </Typography>
                    </Button>
                  ))}

                {canShareProfile ? (
                  sharePartners ? (
                    <ShareModal
                      id={id!}
                      profile={peopleData}
                      onAddThirdParties={handleAddThirdParty}
                    />
                  ) : (
                    <>
                      <NoShareButton />
                      <AskShareButton id={id!} />
                    </>
                  )
                ) : null}

                {hasThird && sharePartners && thirdParties && (
                  <ThirdProfileList thirdParties={thirdParties} />
                )}

                {(context === "rh" || context === "manager") && (
                  <Button
                    onClick={() => navigate(`/app/profile/${id}/succession`)}
                    variant="contained"
                    sx={{ width: "100%", height: "50px" }}
                  >
                    <Typography sx={{ ml: 2 }}>Plan de succession</Typography>
                  </Button>
                )}

                {(context === "rh" || context === "manager") && (
                  <Button
                    onClick={() => navigate(`/app/profile/${id}/projects`)}
                    variant="contained"
                    sx={{ width: "100%", height: "50px" }}
                  >
                    <Typography sx={{ ml: 2 }}>Projets</Typography>
                  </Button>
                )}
                {/* {returnNotCollabContext() && !anonymous && ( */}
                {/* <TagCard personId={id} type={type} needModal={false} /> */}
                {/* )} */}

                {(isCre || context === "advisor" || context === "benef") && (
                  <>
                    <BenefCardTodoInfo
                      person={peopleData}
                      context={context}
                      owner="benef"
                      offerModal={offerModal}
                      isLoading={isLoading}
                      setTab={setTabSide}
                      tab={tabSide}
                      setOwnerModal={setOwnerModal}
                      setOpenDetailModal={setOpenDetailTodo}
                      setTodoDetail={setTodoDetail}
                      progress={tasksProgress}
                      param={home?.paramjson}
                    />
                    {tabSide === 1 && (
                      <>
                        <ProfileTasks
                          tasks={tasks}
                          loading={tasksLoading}
                          setOwnerModal={setOwnerModal}
                          setOpenDetailModal={setOpenDetailTodo}
                          setTodoDetail={setTodoDetail}
                        />
                      </>
                    )}
                  </>
                )}

                {(context === "advisor" || context === "cre") &&
                  home?.paramjson?.projectForBenef &&
                  !home?.paramjson?.hideProjects &&
                  tabSide === 0 && (
                    <LastProjectCard
                      personId={peopleData?.id}
                      context={context}
                      canEditPeople={canEditPeople}
                    />
                  )}

                {isThird && anonymous && (
                  <DeanonymizationButton person={peopleData} />
                )}

                {/* {(id ? completenessData : data)?.completenessOfProfile
                  ?.hasDynamic && (
                  <ProfileTopSoftSkills
                    context={context}
                    completeness={
                      (id ? completenessData : data)?.completenessOfProfile
                    }
                    data={testData?.["hydra:member"]}
                  />
                )} */}

                {(context === "recruiter" || context === "advisor") &&
                  tabSide === 0 && (
                    <ProfileProgression
                      personId={id!}
                      completeness={id ? completenessData : data}
                      profile
                    />
                  )}
                {tabSide === 0 && !anonymous && (
                  <ProfileFileList
                    person={peopleData}
                    testData={testData?.["hydra:member"]}
                  />
                )}
                {!anonymous && tabSide === 0 && (
                  <ProfileOtherInfos notCollab={returnNotCollabContext()} />
                )}
              </Stack>
            }
          />
        </>
      )}
      <MatchingCandidateProfile
        open={openMatchingModal}
        close={() => setOpenMatchingModal(false)}
        person={peopleResponse?.data}
      />

      {openModalResume && experiencesFT && !isLoadingExperiencesFT && (
        <UploadResumeModal
          open={true}
          close={() => {
            handleClose();
          }}
          ftConnect={true}
          experiencesFT={experiencesFT}
        />
      )}
      <TodoModalDetail
        open={openDetailTodo}
        close={() => setOpenDetailTodo(false)}
        todoDetail={todoDetail}
        owner={ownerModal}
        person={peopleData}
        context={context}
      />
    </Page>
  );
};
export default ProfilePage;
